<num-snackbar></num-snackbar>
<num-error-display></num-error-display>
<mat-toolbar>
  <div class="header-left">
    <div class="logo-wrapper">
      <img id="header-logo" [src]="imagePath" alt="{{ urlAlt }}" class="FDPGTheme" />
    </div>
    <div class="breadcrumbs-wrapper">
      <num-breadcrumbs></num-breadcrumbs>
    </div>
  </div>
  <div class="header-right">
    <num-language></num-language>
    <num-header-user-menu></num-header-user-menu>
    <num-header-portal-link></num-header-portal-link>
  </div>
</mat-toolbar>
